// One version-check per app session, shared by the hard ForceUpgradeScreen and
// the soft UpdateNudgeBanner so the service isn't hit twice on launch.
// Resolves to the `version:check` IPC payload or null (web/native/no IPC/error).
let _promise = null;

export function getVersionCheck() {
    if (_promise) return _promise;
    _promise = (async () => {
        try {
            const fn = window.electron?.version?.check;
            if (!fn) return null;
            return (await fn()) || null;
        } catch {
            // Fail open: a broken version check must never block or nag.
            return null;
        }
    })();
    return _promise;
}

// Test hook / hot-reload helper.
export function _resetVersionCheckForTests() {
    _promise = null;
}
